import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import AuthUser from '../../../Components/AuthUser';
import { useReactToPrint } from 'react-to-print';
import http from '../../../http';
import { num } from '../../../converters';
import ReactDatePicker from 'react-datepicker';

export default function ProductWiseReport() {
    const { user } = AuthUser();
    const date = moment().format('YYYY-MM-DD');
    const [filterData, setFilterData] = useState({ startDate: date, endDate: date });
    const [reportData, setReportData] = useState([]);

    const fetchReport = (startDate, endDate) => {
        http.post('product-wise-report', { startDate, endDate })
            .then(res => {
                setReportData(res?.data?.data || []);
            });
    };

    useEffect(() => {
        fetchReport(date, date);
    }, []);

    const handleFilter = () => {
        fetchReport(filterData.startDate, filterData.endDate);
    };

    const reportRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => reportRef.current,
    });

    const totalSalesQty = reportData.reduce((s, r) => s + parseFloat(r.total_sales_qty || 0), 0);
    const totalReturnQty = reportData.reduce((s, r) => s + parseFloat(r.total_return_qty || 0), 0);
    const totalSalesPrice = reportData.reduce((s, r) => {
        const discMrp = parseFloat(r.mrp || 0) * (1 - parseFloat(r.item_discount_percentage || 0) / 100);
        return s + discMrp * parseFloat(r.total_sales_qty || 0);
    }, 0);
    const totalReturnPrice = reportData.reduce((s, r) => {
        const discMrp = parseFloat(r.mrp || 0) * (1 - parseFloat(r.item_discount_percentage || 0) / 100);
        return s + discMrp * parseFloat(r.total_return_qty || 0);
    }, 0);

    return (
        <div className="page-content">
            <div className="row ms-1">
                <div className="col-lg-12 requisition_status_blog">
                    <div className="card mb-2 billing_status">
                        <div className="row mb-1 p-2">
                            <div className="col-sm-4">
                                <div className="row">
                                    <div className="col-3">
                                        <label>Start Date</label>
                                    </div>
                                    <div className="col-9">
                                        <ReactDatePicker
                                            placeholderText="From Date"
                                            selected={filterData.startDate ? new Date(filterData.startDate) : new Date()}
                                            className="form-control form-control-sm custom-datepicker-input-width"
                                            dateFormat="dd/MM/yyyy"
                                            onChange={(d) =>
                                                setFilterData({ ...filterData, startDate: moment(d).format('YYYY-MM-DD') })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="row">
                                    <div className="col-3">
                                        <label>End Date</label>
                                    </div>
                                    <div className="col-9">
                                        <ReactDatePicker
                                            placeholderText="To Date"
                                            selected={filterData.endDate ? new Date(filterData.endDate) : new Date()}
                                            className="form-control form-control-sm custom-datepicker-input-width"
                                            dateFormat="dd/MM/yyyy"
                                            onChange={(d) =>
                                                setFilterData({ ...filterData, endDate: moment(d).format('YYYY-MM-DD') })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <button
                                    style={{ backgroundColor: '#69B128', color: 'white', paddingTop: '6px', paddingBottom: '7px', marginTop: '1px' }}
                                    onClick={handleFilter}
                                    className="btn btn-sm px-4 fw-bold"
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="me-1">
                <div className="custom-card p-2 report-table-wrapper g-doc-scroll">
                    <div className="d-flex justify-content-between">
                        <h6>Product Wise Report</h6>
                        <button onClick={handlePrint} className="btn btn-sm btn-primary float-end">Print</button>
                    </div>
                    <div className="mt-3">
                        <div ref={reportRef} className="daily-sales-report-table">
                            <div className="daily-report">
                                <div className="d-flex justify-content-center">
                                    <div className="text-center">
                                        <h5 className="report-org-name">{user?.organization?.name}</h5>
                                        <p className="report-org-address">{user?.organization?.address}</p>
                                        <p>Tel : {user?.organization?.mobile}</p>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mt-2">
                                    <h6>Product Wise Report</h6>
                                    <h6>
                                        Dated: {moment(filterData.startDate).format('DD/MM/YYYY')} to {moment(filterData.endDate).format('DD/MM/YYYY')}
                                    </h6>
                                </div>
                            </div>

                            <table className="mt-2">
                                <thead>
                                    <tr className="bg-light">
                                        <th>#</th>
                                        <th>Product Name</th>
                                        <th className="text-end">MRP</th>
                                        <th className="text-end">Disc%</th>
                                        <th className="text-end">Disc MRP</th>
                                        <th className="text-end">Sales Qty</th>
                                        <th className="text-end">Sales Amount</th>
                                        <th className="text-end">Return Qty</th>
                                        <th className="text-end">Return Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.length > 0 ? (
                                        reportData.map((item, index) => {
                                            const discMrp = parseFloat(item.mrp || 0) * (1 - parseFloat(item.item_discount_percentage || 0) / 100);
                                            const salesAmt = discMrp * parseFloat(item.total_sales_qty || 0);
                                            const returnAmt = discMrp * parseFloat(item.total_return_qty || 0);
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.product_name}{item?.strength ? ` - ${item.strength}` : ''}{item?.drug_description ? ` - ${item.drug_description}` : ''}</td>
                                                    <td className="text-end">{num(item.mrp)}</td>
                                                    <td className="text-end">{num(item.item_discount_percentage)}%</td>
                                                    <td className="text-end">{num(discMrp)}</td>
                                                    <td className="text-end">{item.total_sales_qty}</td>
                                                    <td className="text-end">{num(salesAmt)}</td>
                                                    <td className="text-end">{item.total_return_qty}</td>
                                                    <td className="text-end">{num(returnAmt)}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">No data found</td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="5" className="text-end">Total</td>
                                        <td className="text-end">{totalSalesQty}</td>
                                        <td className="text-end">{num(totalSalesPrice)}</td>
                                        <td className="text-end">{totalReturnQty}</td>
                                        <td className="text-end">{num(totalReturnPrice)}</td>
                                    </tr>
                                </tfoot>
                            </table>
                            <div className="mt-2 pt-2 text-end" style={{ borderTop: '2px solid #69B128', fontSize: '13px' }}>
                                <span className="me-4">Grand Total: <strong>{num(totalSalesPrice + totalReturnPrice)}</strong></span>
                                <span className="me-4">Return: <strong style={{ color: '#dc3545' }}>{num(totalReturnPrice)}</strong></span>
                                <span>Net: <strong style={{ color: '#198754' }}>{num(totalSalesPrice)}</strong></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
